import { Injectable } from '@angular/core';
import { ToastComponent } from '@syncfusion/ej2-angular-notifications';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  public toast!: ToastComponent;
  constructor() { }

  public warning(title: string, content: string): void {
    this.toast.show({
      title, content,
      cssClass: 'e-toast-warning', icon: 'e-warning toast-icons',
      position: { X: 'Center', Y: 'Top' }, timeOut: 3000, height: '60px'
    });
  }

  public success(title: string, content: string): void {
    this.toast.show({
      title, content,
      cssClass: 'e-toast-success', icon: 'e-success toast-icons',
      position: { X: 'Center', Y: 'Top' }, timeOut: 3000, height: '60px'
    });
  }

  public info(title: string, content: string): void {
    this.toast.show({
      title, content,
      cssClass: 'e-toast-info', icon: 'e-info toast-icons',
      position: { X: 'Center', Y: 'Top' }, timeOut: 3000, height: '60px'
    });
  }

  public error(title: string, content: string): void {
    this.toast.show({
      title, content,
      cssClass: 'e-toast-danger', icon: 'e-error toast-icons',
      position: { X: 'Center', Y: 'Top' }, timeOut: 3000, height: '60px'
    });
  }

}
